import { Map, Record } from 'immutable';

const struct = {
  id:                  undefined,
  title:               undefined,
  typeName:            undefined,
  categoryName:        undefined,
  url:                 undefined,
  metadata:            new Map(),
  isFirst:             false,
  isLast:              false,
  documentInstruction: '',
  documentSampleUrl:   undefined,
  candidateAttribute:  new Map(),
  legacyTag:           undefined,
  documentTag:         new Map()
};

export default class PromptRecord extends Record(struct, 'PromptRecord') {

}
